module.exports = __webpack_public_path__ + "img/spring_trip-20160416-6.74811941.jpg";